import { useState, useEffect } from 'react';
import '../styles/GeneralStyles.css';
import '../styles/ResultSteps.css';
import ImageSelector, { getImageBySelections } from '../utils/imageSelector';
import iconArrowLeft from '../assets/arrow-left.svg'
import iconCalendar from '../assets/calendar.svg'
import checkIcon from '../assets/statuscheck.svg'
import iconWhatsapp from '../assets/whatsappIcon.svg'

const ResultStep = ({ formData, prevStep, nextStep }) => {
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const calculateTotal = () => {
      let sum = 0;
      
      // Recorre los objetos en formData
      Object.values(formData).forEach(item => {
        // Verifica si el item es un objeto y tiene la propiedad value
        if (item && typeof item === 'object' && 'value' in item) {
          sum += parseInt(item.value) || 0;
        }
      });

      // Agrega monto extra según el selectedId de carats
      if (formData.carats?.selectedId) {
        switch(formData.carats.selectedId) {
          case 1:
            sum += 17200;
            break;
          case 2:
            sum += 25800;
            break;
          case 3:
            sum += 30100;
            break;
          case 4:
            sum += 32250;
            break;
          default:
            break;
        }
      }
      
      setTotal(sum);
    };
  
    calculateTotal();
  }, [formData]);

  //img prefix host
  const imgPrefixHost = 'https://cotizador.tressor.com.mx';


  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      
      // Obtener la URL de la imagen seleccionada
      const imageSrc = getImageBySelections(formData);
      
      const summaryData = {
        fld7DjJqjh5bDHNyD: formData.firstName, // Nombre
        fldelyU4vBDBOF9O3: formData.lastName, // Apellido
        fldMXVtTuv9EOOYQw: formData.phone, // Teléfono
        fld2wQtYVaQ6a7YrF: formData.email, // Email
        fldja6eTyEWBvy56H: formData.cutStyle.text, // Corte
        fldNHcaT9OtbeKjaC: formData.ringColor.text, // Color
        fld6jOMs2rxfpTBKW: formData.clarity.text, // Pureza
        fldyErd6FzriKAjgS: formData.carats.text, // Quilates
        fldc7tK5Mo2tN1HfU: formData.montura.text, // Montura
        fldcBLUHyl6uK073T: formData.material.text, // Material
        fldZdy2cdxTK1ybST: total.toLocaleString('en-US'), // Total
        fldwR5HKpjkEuiYNO: imgPrefixHost + imageSrc // URL de la imagen
      };

      console.log(summaryData);
      
      // Llamar a la API serverless en lugar de Airtable directamente
      const response = await fetch('/api/submit-quote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(summaryData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error del servidor:', errorData);
        throw new Error(errorData.error || 'Error al enviar la cotización');
      }
      
      const result = await response.json();
      const data = result.data;
      
      if (data && data.records && data.records.length > 0) {
        setShowModal(true);
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'cotizacion_enviada',
            cotizador: 'tressor'
          });
        }
      } else {
        throw new Error('La respuesta no contiene los datos esperados');
      }
      
    } catch (error) {
      console.error('Error:', error);
      alert('Hubo un error al enviar la cotización');
    } finally {
      setIsLoading(false);
    }
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola, me interesa cotizar un anillo de compromiso con diseño personalizado.');
    window.open(`https://wa.me/525510190234?text=${message}`, '_blank');
  };

  return (
    <div className='container-large'>
      {showModal && (
        <div className="modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(10px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '1rem'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '8px',
            maxWidth: '450px',
            width: '90%',
            textAlign: 'center'
          }}>
            <div className='wrapp-modal-title'>
              <img style={{width: '62px'}} src={checkIcon} alt="check" />
              <h3 className="heading-style-h3">
                ¡Hemos recibido tu solicitud de cotización!
              </h3>
              <p className="text-size-medium text-color-grey">
              Gracias por interesarte en nuestros anillos de compromiso. <br></br> En breve recibirás un correo electrónico con todos los detalles de tu cotización.
              </p>
            </div>
            <p className="text-size-medium text-color-grey">¿Qué te gustaría hacer ahora?</p>
            <a href='/' style={{textDecoration: 'underline', color: 'blue', fontSize: '14px', marginTop: '16px'}}>Volver a empezar</a>
            <div className='wrapp-btns-modal'>
              <button className="button" onClick={() => nextStep()}>
                Agendar cita
                <img src={iconCalendar} alt="calendar" />
              </button>
              <button className="button is-secondary" onClick={handleWhatsApp}>
                Escribir por WhatsApp
                <img src={iconWhatsapp} alt="whatsapp" />
              </button>
            </div>
          </div>
        </div>
      )}
      <div className='wrapp-principal-2-columns'>
        <div className='wrapp-summary'>
        <div className="summary-tables">
            <div className='text-n-options'>
                <h2 className='heading-style-h3 text-align-center'>Revisa y confirma tu diseño</h2>
                <p className='text-size-medium text-color-grey'>¡Estás a un paso de crear el anillo perfecto! Verifica que toda la información sea correcta, desde el corte hasta el material.
                <br />
                <br />
                </p>
            </div>
          <div className="choices-summary">
            <table className="summary-table">
              <tbody>
                <tr className='header-table'>
                  <th className='descriptionFiled'>Descripción</th>
                  <th>Opción seleccionada</th>
                  {/* <th>Valor</th> */}
                </tr>
                <tr>
                  <td className='descriptionFiled'>Quilates</td>
                  <td>{formData.carats.text || '-'}</td>
                 {/* <td>${formData.carats.value || 0}</td> */}
                </tr>
                <tr>
                <td className='descriptionFiled'>Color</td>
                  <td>{formData.ringColor.text || '-'}</td>
                  {/* <td>${formData.ringColor.value || 0}</td> */}
                  
                </tr>
                <tr>
                  <td className='descriptionFiled'>Corte</td>
                  <td>{formData.cutStyle.text || '-'}</td>
                  {/* <td>${formData.cutStyle.value || 0}</td> */}
                  
                </tr>
                <tr>
                <td className='descriptionFiled'>Claridad</td>
                  <td>{formData.clarity.text || '-'}</td>
                  {/* <td>${formData.clarity.value || 0}</td> */}

                  
                </tr>
                <tr>
                  <td className='descriptionFiled'>Montura</td>
                  <td>{formData.montura.text || '-'}</td>
                  {/* <td>${formData.montura.value || 0}</td> */}
                </tr>
                <tr>
                  <td className='descriptionFiled'>Material</td>
                  <td>{formData.material.text || '-'}</td>
                  {/* <td>${formData.material.value || 0}</td> */}
                </tr>
                
              </tbody>
            </table>
          </div>

          <div className="user-data-summary">
          
            <table className="summary-table">
              <tbody>
                <tr className='header-table'>
                  <th className='descriptionFiled'>Descripción</th>
                  <th>Información</th>
                </tr>
                <tr>
                  <td className='descriptionFiled'>Nombre</td>
                  <td>{formData.firstName || '-'}</td>
                </tr>
                <tr>
                  <td className='descriptionFiled'>Apellido</td>
                  <td>{formData.lastName || '-'}</td>
                </tr>
                <tr>
                  <td className='descriptionFiled'>Email</td>
                  <td>{formData.email || '-'}</td>
                </tr>
                <tr>
                  <td className='descriptionFiled'>Teléfono</td>
                  <td>{formData.phone || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='total-price'>
        
        <h2 className='heading-style-h3'>Total $ {total.toLocaleString('en-US')} MXN</h2>
        <p className='text-size-medium text-color-grey' style={{maxWidth: '500px', margin: '0 auto'}}>Este precio es estimado y puede variar según el diseño y la complejidad del anillo.</p>
        </div>
        <div className="wrapp-btns">
          <button className="button-prev" onClick={prevStep}>
            <img src={iconArrowLeft} alt="arrow left" />
            Volver
          </button>
          <button 
            className="button"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Enviando...' : 'Solicitar cotización'}
            
          </button>
        </div>
        </div>
        
        
        </div>
        <div className='wrapp-preview'>
          <p style={{textAlign: 'center', marginBottom: '20px', }}> La imagen mostrada es únicamente referencial. El producto final puede presentar variaciones según los materiales, especificaciones y ajustes seleccionados por el cliente. </p>
            <div className="decorative-img">
                <div className="image-zoom-container" 
                    onClick={() => {
                        const modal = document.getElementById('imageModal');
                        modal.style.display = 'flex';
                    }}>
                    <ImageSelector 
                        formData={formData} 
                        className='imgPreviewNoText' 
                        alt="Preview anillo"
                        style={{cursor: 'zoom-in'}}
                    />
                </div>
            </div>

            {/* Modal para imagen en pantalla completa */}
            <div id="imageModal" 
                className="modal"
                style={{
                    display: 'none',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.9)',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}
                onClick={(e) => {
                    if (e.target.id === 'imageModal') {
                        e.target.style.display = 'none';
                    }
                }}>
                  <button 
                        onClick={() => {
                            document.getElementById('imageModal').style.display = 'none';
                        }}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            background: 'transparent',
                            border: 'none',
                            color: 'white',
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '10px',
                            zIndex: '1000'
                        }}
                    >
                        ✕
                    </button>
                <div className="zoom-wrapper"
                    style={{
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        maxWidth: '90%',
                        maxHeight: '90%',
                        overflow: 'hidden'
                    }}
                    onMouseMove={(e) => {
                        const image = e.currentTarget.querySelector('img');
                        const rect = e.currentTarget.getBoundingClientRect();
                        const x = e.clientX - rect.left;
                        const y = e.clientY - rect.top;
                        const transformOrigin = `${(x / rect.width) * 100}% ${(y / rect.height) * 100}%`;
                        image.style.transformOrigin = transformOrigin;
                    }}
                    onMouseEnter={(e) => {
                        const image = e.currentTarget.querySelector('img');
                        image.style.transform = 'scale(2)';
                    }}
                    onMouseLeave={(e) => {
                        const image = e.currentTarget.querySelector('img');
                        image.style.transform = 'scale(1)';
                    }}>
                    
                    <ImageSelector 
                        formData={formData}
                        className='modal-image'
                        alt="Preview anillo"
                        style={{
                            width: '100%',
                            maxWidth: '800px',
                            transition: 'transform 0.2s ease',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            </div>

            <p style={{textAlign: 'center', marginTop: '20px', fontStyle: 'italic'}}>¿Buscas otro modelo? Envíanos un mensaje a <a href='https://wa.me/+525510190234' target='_blank' rel="noopener noreferrer">+52 (55) 1019 0234</a> y te enviaremos una cotización personalizada.</p>
        </div>
      </div>
    </div>
  );
};

export default ResultStep;
